import React from 'react'
import SplitPage from '@/component/Landmark/SplitPage'
import Sidebar from './component/Sidebar'
import Form from './component/Form'

const LoginPage = (props) => (
  <SplitPage sidebarContent={<Sidebar />}>
    <Form {...props} />
  </SplitPage>
)

export default LoginPage
